<template>
  <div class="layout_wraper">
    <div class="layout_left">
      
      <div class="animate_wrap">
        <div class="down_animate_dely1">
          <img src="../assets/img/view/yardManagement/GrowthRate.png" alt="" />
        </div>
      </div>

      <div class="animate_wrap">
        <div class="down_animate_dely2">
          <img src="../assets/img/view/yardManagement/TradeStatistics.png" alt="" />
        </div>
      </div>

      <div class="animate_wrap">
        <div class="down_animate_dely3">
          <img src="../assets/img/view/yardManagement/InTransitMonitoring.png" alt="" />
        </div>
      </div>

    </div>
    <div class="layout_center">
      <div class="yingjimoni" v-if="sceneName == 'FaDianZhan'" @click="yingjimoniClick"></div>

    </div>
    <div class="layout_right">
      <div class="animate_wrap">
        <div class="down_animate_dely1">
          <img src="../assets/img/view/yardManagement/DailyGrowthTrend.png" alt="" />
        </div>
      </div>

      <div class="animate_wrap">
        <div class="down_animate_dely2">
          <img src="../assets/img/view/yardManagement/ProductRanking.png" alt="" />
        </div>
      </div>

      <div class="animate_wrap">
        <div class="down_animate_dely3">
          <img src="../assets/img/view/yardManagement/ContainerList.png" alt="" />
        </div>
      </div>
      <EmergencyMeeting class="EmergencyMeeting"></EmergencyMeeting>
    </div>
  </div>
</template>

<script>
import HighLight from '../components/common/HighLight';

import MainTitle from '../components/common/MainTitle';
import SecTitle from '../components/common/SecTitle';
import Table from '../components/common/Table';
import Water from '@/components/charts/Water';
import { mapState } from 'vuex';
import CiYunCharts from '@/components/charts/CiYunCharts';
import CreatingVideoConference from '@/components/common/CreatingVideoConference';
import EmergencyMeeting from '@/components/common/EmergencyMeeting';
import TempAddLayer from '../utils/UEapi/TempAddLayer';
export default {
  name: 'ChengShiZhiLi',
  components: {
    Table,
    HighLight,
    MainTitle,
    SecTitle,
    Water,
    CiYunCharts,
    CreatingVideoConference,
    EmergencyMeeting
  },
  computed: {
    ...mapState(['highLight', 'sceneName'])
  },
  data() {
    return {
      isopenMetting: false,
      //党组织分布-表头
      DistributionPartyOrganizationsHeaderListData: [{ name: '名称', width: '406px' }],
      //党组织分布-数据
      DistributionPartyOrganizationsBodyListData: [
        {
          name: '上机架'
        },
        {
          name: '顶轴'
        },
        {
          name: '水轮发电机组'
        },
        {
          name: '水轮发电机组02'
        },
        {
          name: '水轮发电机组03'
        }
      ],
      //点击记录
      dianjijilu: ''
    };
  },

  mounted() {},
  beforeDestroy() {},
  methods: {
    yingjimoniClick() {
      //删除

      TempAddLayer.removeeventLayer();
      this.$store.commit('setHighLight', '应急模拟');
    },
    beginMetting() {
      //关闭弹窗
      this.isopenMetting = false;
    },
    //
    showDepMes(item) {
      debugger;
      if (this.dianjijilu == item.name) {
        this.dianjijilu = '';
        this.$store.commit('setCameraInfo', '发电机组');
      } else {
        this.dianjijilu = item.name;
        this.$store.commit('setCameraInfo', item.name);
      }

      TempAddLayer.higlightMode(item.name);
    }
  },
  watch: {
    highLight: {
      handler(val) {
        if (val == '打开融合通讯') {
          this.isopenMetting = true;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.layout_wraper {
  width: 100%;
  height: 100%;
  position: relative;
  .layout_center {
    .yingjimoni {
      background: url('../assets/img/layout/应急模拟.png');
      transform: scale(0.8);
      pointer-events: all;
      width: 331px;
      height: 63px;
    }
  }

  h1 {
    color: skyblue;
  }

  .metting {
    position: absolute;
    top: 140px;
    left: 620px;
  }
  .jizuClass {
    position: absolute;
    pointer-events: all;
    left: 45px;
  }
  .EmergencyMeeting {
    position: absolute;
    top: 0px;
    left: 0px;
  }
}
</style>
